import createVueComponent from '../createVueComponent';

const BarChart = createVueComponent('BarChartIcon', [
  ['line', { x1: '12', x2: '12', y1: '20', y2: '10', key: '1vz5eb' }],
  ['line', { x1: '18', x2: '18', y1: '20', y2: '4', key: 'cun8e5' }],
  ['line', { x1: '6', x2: '6', y1: '20', y2: '16', key: 'hq0ia6' }],
]);

export default BarChart;
